$.TemplateMarketingDirectory = {
    SearchTimeout: null,

    SearchProduct: (language) => {
        const searchResult = $("#mdProducts");
        const searchResultTable = $("#mdProducts table tbody");
        const searchButtonCaption = searchResult.data("button");
        const notFoundCaption = searchResult.data("not-found");
        const baseURL = searchResult.data("base");

        searchResult.hide();
        searchResultTable.empty();
        $("#supportProduct").hide();

        const search = $("#mdSearchInput").val();
        if (search.trim() === "") return;

        const res = $.Backend.SearchMarketingDirectory(search, language, true);
        res.then(function (response) {
            const data = response.data;
            let products = [];
            if (data.product) {
                products = [data.product];
            } else if (data.products) products = data.products;
            if (products.length === 0) {
                searchResultTable.append(
                    `<tr><td class="align-middle">${notFoundCaption}</td></tr>`
                );
                $("#mdProducts").show();
            } else if (products.length === 1) {
                $.TemplateMarketingDirectory.SelectProduct(
                    baseURL,
                    language,
                    products[0].partNumber
                );
            } else {
                for (let p of products) {
                    searchResultTable.append(`
                          <tr>
                            <td class="align-middle">${p.name}</td>                  
                            <td class="align-middle text-end text-nowrap">#${p.partNumber}</td>
                            <td class="align-middle text-end text-nowrap">
                              <button class="btn btn-vb-primary-outline btn-small" onClick="javascript:$.TemplateMarketingDirectory.SelectProduct('${baseURL}', ${language}, ${p.partNumber})">${searchButtonCaption}</a>
                            </td>
                          </tr>
                        `);
                }
                $("#mdProducts").show();
            }
        });
    },

    AdvancedSearch: (page = 1) => {
        const lang = $("#advancedSearch").data("language") ?? "en";
        const filters = {
            type: [],
            cat: [],
            variantType: [],
        };
        for (let el of $("#advancedSearch [data-filter-prop]")) {
            if (!$(el).prop("checked")) continue;
            const prop = $(el).data("filter-prop");
            const value = $(el).data("filter-value");
            filters[prop].push(value);
        }
        if ($.TemplateMarketingDirectory.SearchTimeout)
            clearTimeout($.TemplateMarketingDirectory.SearchTimeout);
        $.TemplateMarketingDirectory.SearchTimeout = setTimeout(() => {
            $("#advancedSearchResult").empty();
            $("#advancedSearchLoader").show();
            $("#advancedSearchNotFound").hide();
            $("#advancedSearch").find(".pagination").empty();
            $("#advancedSearch").find("#pageNumber").empty();

            const replacement = {
                "&": "&amp;",
                '"': "&quot;",
                "'": "&#039;",
                "<": "&lt;",
                ">": "&gt;",
            };

            $.Backend.MarketingDirectoryAdvancedSearch(filters, page, lang)
                .then(function (response) {
                    if (
                        response.data &&
                        response.data.files &&
                        response.data.files.length > 0
                    ) {
                        const template = $(
                            "#templateMarketingDirectoryFile"
                        ).html();
                        for (let f of response.data.files) {
                            $("#advancedSearchResult").append(
                                $(
                                    template
                                        .replace(/\[\[uuid\]\]/g, f.uuid)
                                        .replace(/\[\[name\]\]/g, f.name)
                                        .replace(
                                            /\[\[htmlDescription\]\]/g,
                                            f.description ?? ""
                                        )
                                        .replace(
                                            /\[\[description\]\]/g,
                                            f.description
                                                ? f.description.replace(
                                                      /(&|"|'|<|>)/g,
                                                      (m) => replacement[m]
                                                  )
                                                : ""
                                        )
                                        .replace(
                                            /\[\[thumbnail\]\]/g,
                                            f.thumbnail ?? ""
                                        )
                                        .replace(
                                            /\[\[variants\]\]/g,
                                            f.variants
                                        )
                                        .replace(
                                            /\[\[variantCount\]\]/g,
                                            f.variants.length
                                        )
                                        .replace(
                                            /\[\[dateAdded\]\]/g,
                                            f.dateAdded
                                        )
                                        .replace(
                                            /\[\[partNumbers\]\]/g,
                                            f.partNumbers.join(", ")
                                        )
                                        .replace(
                                            /\[\[label\]\]/g,
                                            f.label ?? ""
                                        )
                                )
                            );

                            let el = $(`.card[data-uuid=${f.uuid}]`);
                            if (f.thumbnail) {
                                $(el).find(".card-thumbnail > i").remove();
                            } else {
                                $(el).find(".card-thumbnail > img").remove();
                            }
                            if (f.partNumbers.length == 0)
                                $(el).find(".cart-footer > p").remove();
                            if (f.label === null)
                                $(el).find(".card-label").remove();
                        }
                        $.TemplateMarketingDirectory.RefreshCart();

                        let pageStart = Math.max(response.data.page - 2, 1);
                        const pageEnd = Math.min(
                            pageStart + 4,
                            response.data.pages
                        );
                        if (pageEnd - pageStart < 4)
                            pageStart = Math.max(pageEnd - 4, 1);

                        let pagination = "";
                        for (let p = pageStart; p < pageEnd + 1; p++) {
                            pagination += `<li class="page-item${
                                response.data.page === p ? " active" : ""
                            }"><button class="page-link" onClick="javascript:$.TemplateMarketingDirectory.AdvancedSearch(${p});">${p}</button></li>`;
                        }

                        if (page > 1)
                            pagination =
                                `<li class="page-item"><button class="page-link" onClick="javascript:$.TemplateMarketingDirectory.AdvancedSearch(${
                                    page - 1
                                });">&laquo;</button></li>` + pagination;
                        if (page < response.data.pages)
                            pagination = `${pagination}<li class="page-item"><button class="page-link" onClick="javascript:$.TemplateMarketingDirectory.AdvancedSearch(${
                                page + 1
                            });">&raquo;</button></li>`;

                        $("#advancedSearch")
                            .find(".pagination")
                            .html(pagination);

                        $("#advancedSearch")
                            .find("#pageNumber")
                            .html(
                                `${response.data.page} / ${response.data.pages}`
                            );
                    } else $("#advancedSearchNotFound").show();
                    $("#advancedSearchLoader").hide();
                })
                .catch(function () {
                    $("#advancedSearchNotFound").show();
                    $("#advancedSearchLoader").hide();
                });
        }, 1000);
    },

    SelectProduct: (baseURL, language, pn) => {
        window.location.href = `${baseURL}/product/${pn}/#product`;
    },

    ToggleDownload: (uuid, name, description, thumbnail, files) => {
        let cart = sessionStorage.getItem("downloads");
        cart = cart ? JSON.parse(cart) : [];
        if (cart.find((item) => item.uuid === uuid)) {
            cart = cart.filter((item) => item.uuid !== uuid);
        } else cart.push({ uuid, name, description, thumbnail, files });
        sessionStorage.setItem("downloads", JSON.stringify(cart));
        $.TemplateMarketingDirectory.RefreshCart();
    },
    AddDownloads: (data) => {
        let cart = sessionStorage.getItem("downloads");
        cart = cart ? JSON.parse(cart) : [];
        data.forEach((item) => {
            if (!cart.find((_) => _.uuid === item.uuid)) cart.push(item);
        });
        sessionStorage.setItem("downloads", JSON.stringify(cart));
        $.TemplateMarketingDirectory.RefreshCart();
    },
    ClearCart: () => {
        sessionStorage.setItem("downloads", JSON.stringify([]));
        $.TemplateMarketingDirectory.RefreshCart();
    },
    RefreshCart: () => {
        let cart = sessionStorage.getItem("downloads");
        cart = cart ? JSON.parse(cart) : [];

        $("#cart ul").empty();
        $(".card[data-uuid]").removeClass("selected");
        $("button[data-uuid] i")
            .removeClass("icon-trash")
            .addClass("icon-basket");

        const replacement = {
            "&amp;": "&",
            "&quot;": '"',
            "&#039;": "'",
            "&lt;": "<",
            "&gt;": ">",
        };

        let fileCount = 0;
        for (let item of cart) {
            let description = item.description.replace(
                /(&amp;|&quot;|&#039;|&lt;|&gt;)/g,
                (m) => replacement[m]
            );

            $(".card[data-uuid='" + item.uuid + "']").addClass("selected");
            $("button[data-uuid='" + item.uuid + "'] i")
                .removeClass("icon-basket")
                .addClass("icon-trash");
            $("#cart ul").append(
                `<li class="list-group-item d-flex align-items-center justify-content-between">
                    <div class="d-flex">
                      ${
                          item.thumbnail
                              ? `<img src="${item.thumbnail}" class="cart-thumbnail me-1">`
                              : '<div class="cart-no-thumbnail me-1"><i class="icon icon-doc"></i></div>'
                      }
                      <div>
                        <span class="fw-bold mb-1">${item.name}</span>
                        <small>${description}</small>
                      </div>
                    </div>
                    <button class="btn btn-vb-white btn-small" onClick="$.TemplateMarketingDirectory.ToggleDownload('${
                        item.uuid
                    }')">
                      <i class="icon icon-trash"></i>
                    </button>
                </li>`
            );
            fileCount += item.files;
        }

        if (fileCount === 0) {
            $("#cart").hide();
        } else {
            $("#cart").show();
        }

        $("#cart-count").html(fileCount);
    },

    Download: (path, variantId) =>
        $.Backend.MarketingDirectoryDownload(path, variantId),
    DownloadCart: (path) => {
        let cart = sessionStorage.getItem("downloads");
        const uuids = (cart ? JSON.parse(cart) : []).map((item) => item.uuid);
        $.TemplateMarketingDirectory.ClearCart();
        $("#downloadCartOverlay").addClass("show");
        $.Backend.MarketingDirectoryDownloadBundle(path, uuids).then(() =>
            $("#downloadCartOverlay").removeClass("show")
        );
    },

    SetThumbnailPreview: (url) => {
        $("#previewThumbnailModal img").attr("src", url);
    },
};

$(document).ready(function () {
    $("#mdProducts").hide();
    $("#mdSearchInput").on("keypress", function (e) {
        if (e.which === 13) $("#mdSearchBtn").click();
    });
    $("#cart .cart-toggle").on("click", function () {
        $("#cart").toggleClass("show");
    });
    $("#advancedSearch [data-filter-prop]").on("change", function () {
        $.TemplateMarketingDirectory.AdvancedSearch();
    });
    const startSearchValue = ($("#mdSearchInput").val() ?? "").trim();
    if (startSearchValue !== "") $("#mdSearchBtn").click();
    $.TemplateMarketingDirectory.RefreshCart();
    if ($("#advancedSearch").length > 0)
        $.TemplateMarketingDirectory.AdvancedSearch();
});
